import React from 'react'
import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'

let c = 0;

function expandTree(id, expanded) {
    if (!expanded.includes("treeChild-" + id)) {
        expanded.push("treeChild-" + id)
        document.getElementById("treeChild-" + id).style.display = "block"
    } else {
        expanded.pop("treeChild-" + id)
        document.getElementById("treeChild-" + id).style.display = "none"

    }
    return expanded
}

function SubTree({items, model, field, style, id, parent}) {
    let expanded = []
    return (
        <div className={"tree-list"} style={style} id={style ? "treeChild" + "-" + id : ""}>
            {Object.keys(items).sort().map((key, i) => {
                c++;
                if (key === 'Schlüsselwort') return null;

                return (
                    <div style={{display: "inline-flex", width: "100%"}} key={i + "-" + id}>
                        {
                            Object.values(items[key]).length > 0
                                ? <a className={parent || field === 'Zeiterfahrung'  ? "branch-expanded" : "branch"} id={"btn-" + c}
                                    onClick={(e) => {
                                        if (field === 'Zeiterfahrung') return;
                                        e = e || window.event;
                                        e = e.target || e.srcElement;
                                        expanded = expandTree(e.id.replace("btn-", ""), expanded);
                                        if (expanded.includes("treeChild-" + e.id.replace("btn-", "")))
                                            document.getElementById(e.id).className = "branch-expanded"
                                        else
                                            document.getElementById(e.id).className = "branch"
                                    }}></a>
                                : <a className="branch-empty"></a>
                        }
                        <div className={"branh"} key={i}>
                            {
                                !model || !field
                                    ? null
                                    : <SearchLink text={key} model={model} field={field}/>
                            }
                            {
                                field === 'Zeiterfahrung'
                                ? <SubTree items={items[key]} model={model} field={field} style={{display: "block"}}
                                    id={c} parent={items}/>
                                : Object.keys(items[key]) && parent == null
                                    ? <SubTree items={items[key]} model={model} field={field} style={{display: "none"}}
                                            id={c} parent={items}/>
                                    : Object.keys(items[key]) && parent != null
                                        ? <SubTree items={items[key]} model={model} field={field} style={{display: "block"}}
                                                id={c} parent={items}/>
                                        : null
                            }
                        </div>
                    </div>
                )
            })
            }
        </div>
    );
}

function Tree({items, model, field, style, id, parent}) {
    let opened = false;
    if (field === 'Zeiterfahrung') {
        const kwds = items['Schlüsselwort'];
        const s = style || {};
        s['display'] = 'none';
        return (
            <div>
                <div style={{paddingLeft: '1rem'}}>
                {
                    (kwds === undefined)
                    ?   null
                    :   <span>
                        {Object.keys(kwds)
                            .map(text => <SearchLink text={text} model={model} field={field}/>)
                            .reduce((acc, x) => acc === null ? [x] : [acc, ', ', x], null)}
                        </span>
                }
                <div><a style={{fontStyle: 'italic', fontSize: '80%'}} onClick={e => {
                    opened = !opened;
                    e = e || window.event;
                    e = e.target || e.srcElement;
                    // use DOM as state holder here, since we have no proper component class
                    $(e.parentElement.parentElement.parentElement).children('.tree-list').css('display', opened ? 'block' : 'none');
                    $(e).text(opened ? '[weniger]' : '[aufklappen ...]');
                }}>{"[aufklappen ...]"}</a></div>
                </div>
                <SubTree items={items} model={model} field={field} style={s} id={id} parent={parent} />
            </div>
        );
    } else {
        return <SubTree items={items} model={model} field={field} style={style} id={id} parent={parent} />
    }
}

export default Tree;


// WEBPACK FOOTER //
// ./cms_plugins/zitat_display/js/components/Tree.js